export default "<tag *ngFor=\"let temp of tags\" [tag]=\"temp\" (em)=\"ClickFunction($event)\"></tag>";